import { Length } from "$src/CGS/domain/dto/core/Length/Length";
import { InsideElementMetadata, FrontFacePlacementMetadata } from "./InsideElementMetadata";

export class InsideContainerMetadata {
    Elements: InsideElementMetadata[] = [];
    Bottom?: Length;
    Top?: Length;
    VerticalPlankBottom?: Length;
    StartPlacement!: FrontFacePlacementMetadata;
    EndPlacement!: FrontFacePlacementMetadata;
}
